import QRCode from 'qrcode-generator';

/**
 * Dibuja un código QR en un documento jsPDF.
 * @param {string} text - Texto o datos a codificar.
 * @param {object} options - Opciones de posición y tamaño.
 * @param {jsPDF} doc - Instancia del documento jsPDF.
 */
export function drawQRCode(text, options, doc) {
  if (!doc || typeof doc.addImage !== 'function') {
    throw new Error('El parámetro "doc" debe ser una instancia válida de jsPDF.');
  }

  const x = options?.x ?? 10;
  const y = options?.y ?? 10;
  const size = options?.size ?? 40;

  // Generar QR code en formato base64 (Data URL)
  // ✅ Generar QR sincrónicamente
    const qr = QRCode(0, "L");
    qr.addData(text);
    qr.make();
    const qrDataUrl = qr.createDataURL(4); // Escala ajustable  
  // Insertar la imagen en el PDF
  doc.addImage(qrDataUrl, 'PNG', x, y, size, size);
}